import {
  FETCH_INFO_POPUP_CONFIG_PENDING,
  FETCH_INFO_POPUP_CONFIG_REJECTED,
  FETCH_INFO_POPUP_CONFIG_FULFILLED,
  FETCH_ANNOUNCEMENT_POPUP_CONFIG_PENDING,
  FETCH_ANNOUNCEMENT_POPUP_CONFIG_REJECTED,
  FETCH_ANNOUNCEMENT_POPUP_CONFIG_FULFILLED,
  FETCH_COMMON_POPUP_CONFIG_PENDING,
  FETCH_COMMON_POPUP_CONFIG_REJECTED,
  FETCH_COMMON_POPUP_CONFIG_FULFILLED,
} from "../../constants/announcements";

const announcements = (state = {}, action) => {
  switch (action.type) {
    case FETCH_INFO_POPUP_CONFIG_PENDING:
      return { ...state, loading: true, error: false, success: false };
    case FETCH_INFO_POPUP_CONFIG_REJECTED:
      return { ...state, loading: false, error: true, success: false };
    case FETCH_INFO_POPUP_CONFIG_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        info: action.payload.data,
      };
    case FETCH_ANNOUNCEMENT_POPUP_CONFIG_PENDING:
      return {
        ...state,
        announcementLoading: true,
        announcementError: false,
        announcementSuccess: false,
        announcementData: null,
      };
    case FETCH_ANNOUNCEMENT_POPUP_CONFIG_REJECTED:
      return {
        ...state,
        announcementLoading: false,
        announcementError: true,
        announcementSuccess: false,
        announcementData: null,
      };
    case FETCH_ANNOUNCEMENT_POPUP_CONFIG_FULFILLED:
      return {
        ...state,
        announcementLoading: false,
        announcementError: false,
        announcementSuccess: true,
        announcementData: action.payload.data,
      };
    case FETCH_COMMON_POPUP_CONFIG_PENDING:
      return {
        ...state,
        commonPopupLoading: true,
        commonPopupError: false,
        commonPopupSuccess: false,
      };
    case FETCH_COMMON_POPUP_CONFIG_REJECTED:
      return {
        ...state,
        commonPopupLoading: false,
        commonPopupError: true,
        commonPopupSuccess: false,
      };
    case FETCH_COMMON_POPUP_CONFIG_FULFILLED:
      const { data, announcementType } = action.payload;

      let currentCommonPopupData =
        state?.commonPopupData &&
        typeof state.commonPopupData === "object" &&
        !Array.isArray(state.commonPopupData)
          ? { ...state.commonPopupData }
          : {};

      if (announcementType === "infoConfig") {
        currentCommonPopupData.infoConfig = data?.Data?.infoConfig;
      } else if (announcementType === "announcementConfig") {
        currentCommonPopupData.announcementConfig =
          data?.Data?.announcementConfig;
      }

      return {
        ...state,
        commonPopupLoading: false,
        commonPopupError: false,
        commonPopupSuccess: true,
        commonPopupData: currentCommonPopupData,
      };
    default:
      return state;
  }
};

export default announcements;
